import {
  CompanySettings,
  CompanySettingsRaw,
  HRIS_PROVIDER,
} from '../../interfaces/company-settings';

export const sanitizeCompanySettingsFromRaw = (
  data: CompanySettingsRaw
): CompanySettings => {
  return {
    isHRISProviderUKG: data.hris_provider === HRIS_PROVIDER.UKG,
    autoDeleteVideoAfterAnalysis: data.auto_delete_video_after_analysis,
    hideInsightEvidenceQuotes: data.hide_insight_evidence_quotes,
    meetingDataPolicyLocked: data.meeting_data_policy_locked,
  };
};

export const sanitizeCompanySettingsForRaw = (
  data: Partial<CompanySettings>
): Partial<CompanySettingsRaw> => {
  return {
    ...(data.autoDeleteVideoAfterAnalysis !== undefined && {
      auto_delete_video_after_analysis: data.autoDeleteVideoAfterAnalysis,
    }),
    ...(data.hideInsightEvidenceQuotes !== undefined && {
      hide_insight_evidence_quotes: data.hideInsightEvidenceQuotes,
    }),
    ...(data.isHRISProviderUKG !== undefined && {
      hris_provider: data.isHRISProviderUKG ? HRIS_PROVIDER.UKG : null,
    }),
  };
};
